import React from "react"

export function LoadingSpinner() {
    return (
        <div className="loading-container">
            <span className="loading-line"></span>
        </div>
    );
}